import apiService from '../baseApiService';

const feedService = {
    getFeed: async () => {
        return await apiService.get('/v1/feed');
    },
};

export default feedService;
